import React, { VFC } from 'react';
import { useTranslation } from 'react-i18next';
import { capitalizeFirstLetter } from '@dxb-web-ui-framework/common/utils';
import { Chip } from '@dxb-web-ui-framework/design-system';
import { getCardTransactionsChipProps } from '../../utils';

interface CardTransactionStatusChipProps {
  cardTransactionStatus?: string;
}

export const CardTransactionStatusChip: VFC<CardTransactionStatusChipProps> = ({ cardTransactionStatus }) => {
  const { t } = useTranslation();

  if (!cardTransactionStatus) {
    return null;
  }

  const chipProps = getCardTransactionsChipProps(cardTransactionStatus, t);

  return <Chip label={capitalizeFirstLetter(chipProps.value)} bgColor={chipProps.color as any} />;
};
